import React from 'react';
import { Alert } from '@mui/material';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Button, Input } from '../../../ui';
import { ErrorIcon } from '../../../ui/icons';
import type { NameFormValues } from './useNameStep';
import { isFullNameInvalid } from '../../../../utils/fullNameCheck';

type AuthNameStepViewProps = {
    register: UseFormRegister<NameFormValues>;
    errors: FieldErrors<NameFormValues>;
    loading?: boolean;
    defaultName?: string;
    onSubmit?: React.FormEventHandler<HTMLFormElement>;
    onAlreadyHaveAccount?: () => void;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthNameStepView: React.FC<AuthNameStepViewProps> = ({
    register,
    errors,
    loading,
    defaultName,
    onSubmit,
    onAlreadyHaveAccount,
    error,
    dismissError,
}) => (
    <form id="auth-name-form" onSubmit={onSubmit}>
        <div
            id="auth-name-step"
            className="flex flex-col mt-8 w-full min-h-[412px]"
        >
            <div
                id="auth-name-introduction"
                className="text-body-small text-secondary mb-1"
            >
                Looks like you&apos;re new!
            </div>
            <div
                id="auth-name-heading"
                className="text-body-large text-primary mb-6"
            >
                What is your full name?
            </div>
            <Input
                {...register('name', {
                    required: '*Please enter first and last name',
                    validate: (value) =>
                        !isFullNameInvalid(value) ||
                        '*Please enter first and last name',
                })}
                type="text"
                label="Full Name"
                defaultValue={defaultName}
                error={!!errors.name}
                helperText={errors.name?.message}
                id="auth-name"
            />
            <Button
                id="auth-name-existing-account-button"
                type="button"
                className="text-body-small text-accent mt-4 self-start"
                onClick={onAlreadyHaveAccount}
                variant="link"
            >
                Already have an account?
            </Button>
            {error ? (
                <Alert
                    id="auth-name-error-alert"
                    className="mt-6"
                    severity="error"
                    onClose={dismissError}
                    iconMapping={{ error: <ErrorIcon /> }}
                >
                    {error}
                </Alert>
            ) : null}
            <Button
                id="auth-name-next-button"
                type="submit"
                className="w-full mt-auto"
                loading={loading}
            >
                Next
            </Button>
        </div>
    </form>
);
